import vars from '@/config/vars';
import store from '@/store';
import PaymentTypes from '@/models/PaymentTypes';
import axios from '@/config/axios.config';
import binQueryErrorHelper from '@/helpers/binQueryErrorHelper';

export default {
    namespaced: true,

    state: {
        CardNumber: null,
        Holder: null,
        Expiration: {
            Month: null,
            Year: null
        },
        SecurityCode: null,
        BinQueryError: null,
        idPayDeviceID: null
    },

    getters: {
        /**
         * Retorna os 4 últimos dígitos do cartão ou um pleceholder caso null.
         */
        getLast4DigitsFromCardNumber: state => (state.CardNumber) ? state.CardNumber.slice(-4) : '****',

        /**
         * Retorna o nome do portador do cartão.
         */
        getCardHolderName: state => state.Holder || 'Sem nome',

        /**
         * Monta o contrato de autorização
         */
        getSubmitModel(state) {
            return {
                Card: {
                    Number: state.CardNumber,
                    Holder: state.Holder,
                    Month: state.Expiration.Month,
                    Year: `20${state.Expiration.Year}`,
                    SecurityCode: state.SecurityCode,
                    ...store.getters['mpi/getSubmitModel'],
                    ...store.getters['billingAddress/getSubmitModel'],
                },
                idPayDeviceID: state.idPayDeviceID
            };
        },

        /**
         * Retorna o Bin do cartão
         */
        getCardBin: state => (state.CardNumber) ? state.CardNumber.substring(0, 8) : 0,

        /**
         * retorna a msg de erro da consulta de bandeira
         */
        getBinQueryError: state => state.BinQueryError,
    },

    mutations: {
        setCardNumber: (state, cardNumber) => state.CardNumber = cardNumber,
        setHolder: (state, cardHolder) => state.Holder = cardHolder,
        setExpirationMonth: (state, expirationMonth) => state.Expiration.Month = expirationMonth,
        setExpirationYear: (state, expirationYear) => state.Expiration.Year = expirationYear,
        setSecurityCode: (state, securityCode) => state.SecurityCode = securityCode,
        
        resetState(state) {
            state.CardNumber = null,
            state.Holder = null,
            state.Expiration = {
                Month: null,
                Year: null
            };
            state.SecurityCode = null;
        },

        /**
         * setta a msg de erro da consulta de bandeira
         */
        setBinQueryError: (state, value) => state.BinQueryError = binQueryErrorHelper.getBinQueryErrorMsg(value),
    },

    actions: {
        async fetchCardBrand({ getters, dispatch, commit, rootState }) {
            let cardBin = getters.getCardBin;
            let paymentType = store.state.payment.PaymentType;
            let preorderId = rootState.preorder.Id;
            
            let response;

            if (paymentType == PaymentTypes.VOUCHER)
                response = buildAleloResponse(rootState);
            else if (vars.USE_SIMULATED_MODE)
                response = await new Promise(resolve => setTimeout(() => resolve(buildSimulatedResponse()), 1000));
            else
                response = await axios.get(`brand/${preorderId}/${paymentType}/${cardBin}`);
            
            if(!response.data.Success) {
                commit('setBinQueryError', response.data.ReasonError || '');
            }

            // TODO: Verificar se resposta for vazia, meio de pagamento não suportado
            let paymentMethodId = response.data.PaymentMethodId;
            let maxNumberOfPayments = 0;

            if(response.data.InstallmentsInfo !== null && response.data.InstallmentsInfo.length > 0)
                maxNumberOfPayments = response.data.InstallmentsInfo.length;

            commit(
                'payment/setPaymentMethodNumberOfInstallments', 
                {
                    paymentMethodId, 
                    maxNumberOfPayments
                },
                { root: true });
            dispatch('payment/setPaymentMethod', paymentMethodId, { root: true });
        }
    }
};

/**
 * ATENÇÃO!!
 * Neste primeiro momento só teremos voucher alelo, 
 * em um momento em que mais vouchers precisarem ser 
 * implementados, essa validação precisa sair daqui 
 * e talvez realizar uma consulta bin na cielo para 
 * saber se é um voucher e qual a bandeira
 */
function buildAleloResponse(rootState) {
    return {
        data: {
            PaymentMethodId: rootState.preorder.DebitCardAleloPaymentMethod,
            InstallmentsInfo: [
                { Installments: 1 }
            ]
        }
    };
}

function buildSimulatedResponse() {
    return {
        data: {
            Brand:'Master',
            PaymentMethodId: 2,
            Success: true,
            ReasonError: null,
            InstallmentsInfo: [
                { Installments: 1 },
                { Installments: 2 },
                { Installments: 3 },
                { Installments: 4 },
                { Installments: 5 },
                { Installments: 6 },
                { Installments: 7 },
                { Installments: 8 }
            ]
        }
    };
}